var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.608,
    height: 18.42,
    viewBox: "0 0 26.608 18.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u110B\\u116E_\\u1112_\\u1109\\u1161\\u11AF\\u1111\\u116D",
    "data-name": "\\u110B\\u116E \\u1112\\u116A\\u1109\\u1161\\u11AF\\u1111\\u116D",
    transform: "translate(0.25 0.354)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_30",
    "data-name": "\\uADF8\\uB8F9 30",
    transform: "translate(0 8.501)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_3",
    "data-name": "\\uC0AC\\uAC01\\uD615 3",
    width: 25.197,
    height: 0.863,
    stroke: "#000",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_31",
    "data-name": "\\uADF8\\uB8F9 31",
    transform: "translate(16.441 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_4",
    "data-name": "\\uC0AC\\uAC01\\uD615 4",
    width: 0.863,
    height: 12.197,
    transform: "translate(0 0.61) rotate(-45)",
    stroke: "#000",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_32",
    "data-name": "\\uADF8\\uB8F9 32",
    transform: "translate(16.594 8.348)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_5",
    "data-name": "\\uC0AC\\uAC01\\uD615 5",
    width: 12.413,
    height: 0.863,
    transform: "translate(0 8.754) rotate(-44.842)",
    stroke: "#000",
    strokeWidth: 0.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right_arrow.1d28c3bd3d8f1d6ff1c8bf9d92f963a8.svg";
export { ForwardRef as ReactComponent };